var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkSelectArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14581 13.5L6.85991 7.34004L6.85991 6.65996L1.14581 0.5L5.29221 0.5L11.3182 7L5.29221 13.5L1.14581 13.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkSelectArrowRight);
export default __webpack_public_path__ + "static/media/parkSelectArrowRight.8fd69cc50125ad6f0ce74f7d6affd7c8.svg";
export { ForwardRef as ReactComponent };